import React, { FC } from 'react';
import { IYAText } from './YAText.types';
import { cn } from '@bem-react/classname';
import './YAText.styles.scss';

const CnYAText = cn('yatext');

const YAText: FC<IYAText> = (props) => {
  const { elementBefore, text, style, onClick, type, className, isBold } = props;
  return (
    <span
      onClick={onClick}
      style={style}
      className={`${CnYAText({ type: type, isBold })} ${className}`}
    >
      {elementBefore}
      {text}
    </span>
  );
};

export default YAText;
